import { Box, Flex } from '@chakra-ui/react';
import { BodyOverride } from '../../../shared/BodyOverride';
import { ErrorDetails } from '../../../shared/alert/ErrorDetails';
import { FeatureGuard } from '../../../shared/featureGuard/FeatureGuard';
import {
  BranchCoverage,
  DevelopmentFlow,
  OverviewHeader,
} from './PdOverviewSections';
import { usePdOverview } from './usePdOverview';

interface Props {
  isMatrix: boolean;
  variantId: number;
}
export function ProductDevelopmentOverview({ isMatrix, variantId }: Props) {
  const {
    branchesLoading,
    currentBranchId,
    error,
    isLoading,
    overview,
    scopeLabel,
  } = usePdOverview(isMatrix, variantId);

  return (
    <BodyOverride>
      <Box
        bg="entityDirectory.canvas"
        minH="calc(100dvh - 2rem)"
        px={{ base: 4, xl: 11 }}
        py={{ base: 6, xl: 9 }}
        position="relative"
      >
        <Flex direction="column" gap={6} maxW="1200px" mx="auto">
          <ErrorDetails error={error} />
          <OverviewHeader isLoading={branchesLoading} scopeLabel={scopeLabel} />
          <DevelopmentFlow
            isOnTrack={overview.hasActivityAcrossEveryStage}
            stages={overview.stages}
          />
          <FeatureGuard hideBadge={true}>
            <BranchCoverage
              currentBranchId={currentBranchId}
              isLoading={isLoading}
              rows={overview.branchRows}
            />
          </FeatureGuard>
        </Flex>
      </Box>
    </BodyOverride>
  );
}
